import { render, staticRenderFns } from "./BookingClaim.vue?vue&type=template&id=abecdf5c&scoped=true"
import script from "./BookingClaim.vue?vue&type=script&lang=js"
export * from "./BookingClaim.vue?vue&type=script&lang=js"
import style0 from "./BookingClaim.vue?vue&type=style&index=0&id=abecdf5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abecdf5c",
  null
  
)

export default component.exports